package com.evoapps.evoshift.data.remote

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.booleanOrNull
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

/**
 * Reads claims of a Firebase ID token (a JWT) without verifying it: the token comes from the
 * Firebase Auth SDK of this app, and the server verifies every token it receives anyway. Used
 * where the SDK has no accessor for a claim (the desktop app's SDK has no `isEmailVerified`, SH-97).
 */
object IdTokenClaims {
    @OptIn(ExperimentalEncodingApi::class)
    private val base64 = Base64.UrlSafe.withPadding(Base64.PaddingOption.ABSENT_OPTIONAL)

    /** The token's payload, or null when [token] is no JWT. */
    fun payload(token: String?): JsonObject? {
        val part = token?.split('.')?.takeIf { it.size == 3 }?.get(1) ?: return null
        return runCatching {
            @OptIn(ExperimentalEncodingApi::class)
            val json = base64.decode(part).decodeToString()
            Json.parseToJsonElement(json).jsonObject
        }.getOrNull()
    }

    /** The `email_verified` claim; false when it is missing or the token cannot be read. */
    fun emailVerified(token: String?): Boolean =
        payload(token)?.get("email_verified")?.jsonPrimitive?.booleanOrNull ?: false
}
